var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g3, _path53, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 127,
    viewBox: "0 0 209 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1133_1348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 6.89543 0.895431 6 2 6H196.054C197.158 6 198.054 6.89543 198.054 8V104.143H0V8Z",
    fill: "url(#paint0_radial_1133_1348)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.165 8C0.165 6.98656 0.986557 6.165 2 6.165H196.054C197.067 6.165 197.889 6.98656 197.889 8V103.978H0.165V8Z",
    stroke: "#455E52",
    strokeWidth: 0.330001
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_1133_1348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.333 2C44.333 0.895432 45.2284 0 46.333 0H202.054C203.158 0 204.054 0.895431 204.054 2V93.1392C204.054 94.2438 203.158 95.1392 202.054 95.1392H46.333C45.2284 95.1392 44.333 94.2438 44.333 93.1392V2Z",
    fill: "url(#paint1_radial_1133_1348)",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.333 6L38.333 101.139",
    stroke: "#455E52",
    strokeWidth: 0.330001
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.165 101.304H197.889V124.611C197.889 125.625 197.067 126.446 196.054 126.446H2C0.986558 126.446 0.165 125.625 0.165 124.611V101.304Z",
    fill: "#293831",
    stroke: "#455E52",
    strokeWidth: 0.330001
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5809 117.868C97.7862 117.868 99.5739 116.081 99.5739 113.875C99.5739 111.67 97.7862 109.882 95.5809 109.882C93.3756 109.882 91.5879 111.67 91.5879 113.875C91.5879 116.081 93.3756 117.868 95.5809 117.868Z",
    stroke: "#455E52",
    strokeWidth: 0.660001
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M139.193 36.9725L125.817 23.3465L125.006 22.5201L122.579 23.3465L109.205 36.9725V39.8926L120.227 31.925C120.227 31.925 121.635 31.1798 121.635 36.6246V60.2814C121.594 64.8488 120.406 64.2001 120.406 64.2001L109.193 56.1133L109.207 58.9596L124.194 74.2044L126.761 71.638V36.6246C126.761 31.1836 128.168 31.9231 128.17 31.925L139.193 39.8926V36.9725Z",
    fill: "#293831"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9912 46.1514C62.9912 44.7731 64.1085 43.6558 65.4868 43.6558H78.8431C80.2214 43.6558 81.3387 44.7731 81.3387 46.1514V84.0203H62.9912V46.1514Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5759 40.2935C68.5759 40.1927 68.6125 40.0954 68.6788 40.0196L72.1651 36.0354L75.6513 40.0196C75.7177 40.0954 75.7542 40.1927 75.7542 40.2935V43.6556H68.5759V40.2935Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6927 62.6463C66.6927 62.4437 66.857 62.2794 67.0596 62.2794C67.2623 62.2794 67.4265 62.4437 67.4265 62.6463V81.3016H66.6927V62.6463Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0967 62.6463C70.0967 62.4437 70.2609 62.2794 70.4636 62.2794C70.6662 62.2794 70.8305 62.4437 70.8305 62.6463V81.3016H70.0967V62.6463Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5006 62.6463C73.5006 62.4437 73.6649 62.2794 73.8675 62.2794C74.0701 62.2794 74.2344 62.4437 74.2344 62.6463V81.3016H73.5006V62.6463Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9039 62.6463C76.9039 62.4437 77.0682 62.2794 77.2708 62.2794C77.4735 62.2794 77.6377 62.4437 77.6377 62.6463V81.3016H76.9039V62.6463Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9291 47.9954C78.1318 47.9954 78.296 48.1596 78.296 48.3623C78.296 48.5649 78.1318 48.7292 77.9291 48.7292L66.4007 48.7292C66.1981 48.7292 66.0338 48.5649 66.0338 48.3623C66.0338 48.1596 66.1981 47.9954 66.4007 47.9954L77.9291 47.9954Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9291 50.5692C78.1318 50.5692 78.296 50.7335 78.296 50.9361C78.296 51.1387 78.1318 51.303 77.9291 51.303L66.4007 51.303C66.1981 51.303 66.0338 51.1387 66.0338 50.9361C66.0338 50.7335 66.1981 50.5692 66.4007 50.5692L77.9291 50.5692Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9291 53.1431C78.1318 53.1431 78.296 53.3074 78.296 53.51C78.296 53.7127 78.1318 53.8769 77.9291 53.8769L66.4007 53.8769C66.1981 53.8769 66.0338 53.7127 66.0338 53.51C66.0338 53.3074 66.1981 53.1431 66.4007 53.1431L77.9291 53.1431Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9291 55.717C78.1318 55.717 78.296 55.8812 78.296 56.0839C78.296 56.2865 78.1318 56.4508 77.9291 56.4508L66.4007 56.4508C66.1981 56.4508 66.0338 56.2865 66.0338 56.0839C66.0338 55.8812 66.1981 55.717 66.4007 55.717L77.9291 55.717Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9291 58.2909C78.1318 58.2909 78.296 58.4552 78.296 58.6578C78.296 58.8604 78.1318 59.0247 77.9291 59.0247L66.4007 59.0247C66.1981 59.0247 66.0338 58.8604 66.0338 58.6578C66.0338 58.4552 66.1981 58.2909 66.4007 58.2909L77.9291 58.2909Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7272 42.751C83.7272 41.3727 84.8445 40.2554 86.2228 40.2554H101.125C102.503 40.2554 103.62 41.3727 103.62 42.751V84.0203H83.7272V42.751Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.114 18.3328C92.114 18.0907 92.3103 17.8945 92.5524 17.8945C92.7944 17.8945 92.9907 18.0907 92.9907 18.3328V40.2553H92.114V18.3328Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3557 26.8512C94.3557 26.6092 94.552 26.4129 94.7941 26.4129C95.0361 26.4129 95.2324 26.6092 95.2324 26.8512V40.2553H94.3557V26.8512Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.563 67.1636L101.563 71.6576L95.2607 71.6576L95.2607 67.1636L101.563 67.1636Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.563 59.662L101.563 64.156L95.2607 64.156L95.2607 59.662L101.563 59.662Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101.563 52.1604L101.563 56.6545L95.2607 56.6545L95.2607 52.1604L101.563 52.1604Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M101.563 44.6589L101.563 49.1529L95.2607 49.1529L95.2607 44.6589L101.563 44.6589Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6652 74.6652L92.6652 79.1593L86.3627 79.1593L86.3627 74.6652L92.6652 74.6652Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.563 74.6652L101.563 79.1593L95.2607 79.1593L95.2607 74.6652L101.563 74.6652Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6652 67.1636L92.6652 71.6576L86.3627 71.6576L86.3627 67.1636L92.6652 67.1636Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6652 59.662L92.6652 64.156L86.3627 64.156L86.3627 59.662L92.6652 59.662Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6652 52.1604L92.6652 56.6545L86.3627 56.6545L86.3627 52.1604L92.6652 52.1604Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6652 44.6589L92.6652 49.1529L86.3627 49.1529L86.3627 44.6589L92.6652 44.6589Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M145.236 44.09C145.493 43.8332 145.909 43.8332 146.166 44.09C146.422 44.3468 146.422 44.7631 146.166 45.0198L117.517 73.6685L116.587 72.7387L145.236 44.09Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M145.278 47.981C145.511 47.7028 145.926 47.6665 146.204 47.8999C146.483 48.1333 146.519 48.5481 146.285 48.8262L117.67 82.9293L116.662 82.084L145.278 47.981Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M145.123 54.1898C145.331 53.8924 145.741 53.8201 146.039 54.0284C146.336 54.2367 146.408 54.6466 146.2 54.9441L125.94 83.8784L124.863 83.1242L145.123 54.1898Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M145.09 60.5495C145.272 60.235 145.674 60.1273 145.988 60.3089C146.303 60.4904 146.41 60.8925 146.229 61.207L133.059 84.0173L131.921 83.3598L145.09 60.5495Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M146.166 44.0108C145.909 43.754 145.493 43.754 145.236 44.0108C144.979 44.2675 144.979 44.6838 145.236 44.9406L182.408 82.1133L183.338 81.1834L146.166 44.0108Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M146.123 47.981C145.89 47.7028 145.475 47.6665 145.197 47.8999C144.919 48.1333 144.883 48.5481 145.116 48.8262L173.047 82.1132L174.054 81.268L146.123 47.981Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M146.078 53.9715C145.87 53.674 145.46 53.6017 145.162 53.81C144.865 54.0183 144.792 54.4283 145.001 54.7257L165.436 83.9111L166.514 83.1569L146.078 53.9715Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M146.292 60.5495C146.11 60.235 145.708 60.1273 145.393 60.3089C145.079 60.4904 144.971 60.8925 145.153 61.207L158.079 83.5955L159.218 82.938L146.292 60.5495Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M144.824 42.4973C144.824 42.0132 145.217 41.6207 145.701 41.6207C146.185 41.6207 146.578 42.0132 146.578 42.4973L146.578 83.0431L144.824 83.0431L144.824 42.4973Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M105.631 59.1058C105.631 57.7275 106.748 56.6102 108.127 56.6102H115.771C117.149 56.6102 118.267 57.7275 118.267 59.1058V84.4084H105.631V59.1058Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M109.478 54.6031C109.478 54.3734 109.664 54.1871 109.893 54.1871H114.005C114.235 54.1871 114.421 54.3734 114.421 54.6031V56.6102H109.478V54.6031Z",
    fill: "#597364",
    stroke: "#293831",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M108.18 59.5815C108.18 59.442 108.293 59.3289 108.432 59.3289C108.572 59.3289 108.685 59.442 108.685 59.5815V81.6897H108.18V59.5815Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M110.524 59.5815C110.524 59.442 110.637 59.3289 110.777 59.3289C110.916 59.3289 111.029 59.442 111.029 59.5815V81.6897H110.524V59.5815Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M112.869 59.5815C112.869 59.442 112.982 59.3289 113.121 59.3289C113.261 59.3289 113.374 59.442 113.374 59.5815V81.6897H112.869V59.5815Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M115.213 59.5815C115.213 59.442 115.326 59.3289 115.465 59.3289C115.605 59.3289 115.718 59.442 115.718 59.5815V81.6897H115.213V59.5815Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M172.76 58.7176C172.76 57.3393 173.877 56.222 175.255 56.222H182.9C184.278 56.222 185.395 57.3393 185.395 58.7176V84.0202H172.76V58.7176Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M176.606 54.2149C176.606 53.9852 176.792 53.799 177.022 53.799H181.134C181.363 53.799 181.55 53.9852 181.55 54.2149V56.222H176.606V54.2149Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M175.309 59.1934C175.309 59.0539 175.422 58.9407 175.561 58.9407C175.701 58.9407 175.814 59.0539 175.814 59.1934V81.3016H175.309V59.1934Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M177.653 59.1935C177.653 59.0539 177.766 58.9408 177.906 58.9408C178.045 58.9408 178.158 59.0539 178.158 59.1935V81.3017H177.653V59.1935Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M179.997 59.1934C179.997 59.0539 180.11 58.9407 180.25 58.9407C180.389 58.9407 180.503 59.0539 180.503 59.1934V81.3016H179.997V59.1934Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M182.342 59.1935C182.342 59.0539 182.455 58.9408 182.594 58.9408C182.734 58.9408 182.847 59.0539 182.847 59.1935V81.3017H182.342V59.1935Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M176.895 82.4937C177.379 82.492 177.773 82.8832 177.775 83.3673C177.776 83.8515 177.385 84.2454 176.901 84.2471L114.506 84.4662C114.022 84.4679 113.628 84.0768 113.627 83.5926C113.625 83.1084 114.016 82.7145 114.5 82.7128L176.895 82.4937Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.207969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6906 45.0708C23.6906 45.923 23.455 46.7202 23.0453 47.4007L19.1666 54.1189L15.288 47.4009C14.8782 46.7203 14.6426 45.9231 14.6426 45.0708C14.6426 42.5723 16.668 40.5468 19.1666 40.5468C21.6651 40.5468 23.6906 42.5723 23.6906 45.0708ZM19.1662 47.3328C20.4155 47.3328 21.4282 46.3201 21.4282 45.0708C21.4282 43.8215 20.4155 42.8088 19.1662 42.8088C17.9169 42.8088 16.9042 43.8215 16.9042 45.0708C16.9042 46.3201 17.9169 47.3328 19.1662 47.3328Z",
    fill: "url(#paint2_linear_1133_1348)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85354 60.3448H10.3115C10.7075 60.3448 11.0115 60.4448 11.2235 60.6448C11.4395 60.8408 11.5475 61.1088 11.5475 61.4488C11.5475 61.6888 11.4875 61.8808 11.3675 62.0248C11.2515 62.1688 11.0855 62.2728 10.8695 62.3368V62.3668C11.1215 62.4268 11.3195 62.5368 11.4635 62.6968C11.6115 62.8528 11.6855 63.0748 11.6855 63.3628C11.6855 63.5388 11.6555 63.6988 11.5955 63.8428C11.5395 63.9828 11.4575 64.1048 11.3495 64.2088C11.2455 64.3128 11.1175 64.3928 10.9655 64.4488C10.8175 64.5048 10.6495 64.5328 10.4615 64.5328H8.85354V60.3448ZM10.2215 63.9628C10.4415 63.9628 10.6055 63.9228 10.7135 63.8428C10.8255 63.7588 10.8815 63.6168 10.8815 63.4168V63.2188C10.8815 63.0228 10.8255 62.8848 10.7135 62.8048C10.6055 62.7208 10.4415 62.6788 10.2215 62.6788H9.62154V63.9628H10.2215ZM10.1195 62.1328C10.3315 62.1328 10.4875 62.0948 10.5875 62.0188C10.6915 61.9428 10.7435 61.8108 10.7435 61.6228V61.4248C10.7435 61.2368 10.6915 61.1048 10.5875 61.0288C10.4875 60.9528 10.3315 60.9148 10.1195 60.9148H9.62154V62.1328H10.1195ZM13.7712 64.6048C13.4992 64.6048 13.2632 64.5568 13.0632 64.4608C12.8632 64.3608 12.6972 64.2188 12.5652 64.0348C12.4372 63.8508 12.3412 63.6248 12.2772 63.3568C12.2172 63.0888 12.1872 62.7828 12.1872 62.4388C12.1872 62.0988 12.2172 61.7948 12.2772 61.5268C12.3412 61.2548 12.4372 61.0268 12.5652 60.8428C12.6972 60.6588 12.8632 60.5188 13.0632 60.4228C13.2632 60.3228 13.4992 60.2728 13.7712 60.2728C14.3152 60.2728 14.7152 60.4628 14.9712 60.8428C15.2272 61.2228 15.3552 61.7548 15.3552 62.4388C15.3552 63.1228 15.2272 63.6548 14.9712 64.0348C14.7152 64.4148 14.3152 64.6048 13.7712 64.6048ZM13.7712 63.9628C13.9112 63.9628 14.0292 63.9368 14.1252 63.8848C14.2212 63.8288 14.2972 63.7508 14.3532 63.6508C14.4132 63.5508 14.4552 63.4288 14.4792 63.2848C14.5072 63.1368 14.5212 62.9728 14.5212 62.7928V62.0788C14.5212 61.7188 14.4652 61.4348 14.3532 61.2268C14.2452 61.0188 14.0512 60.9148 13.7712 60.9148C13.4912 60.9148 13.2952 61.0188 13.1832 61.2268C13.0752 61.4348 13.0212 61.7188 13.0212 62.0788V62.7988C13.0212 63.1588 13.0752 63.4428 13.1832 63.6508C13.2952 63.8588 13.4912 63.9628 13.7712 63.9628ZM17.3208 64.6048C16.9608 64.6048 16.6528 64.5428 16.3968 64.4188C16.1448 64.2948 15.9388 64.1308 15.7788 63.9268L16.2528 63.4348C16.4088 63.6148 16.5768 63.7488 16.7568 63.8368C16.9408 63.9208 17.1368 63.9628 17.3448 63.9628C17.5848 63.9628 17.7688 63.9088 17.8968 63.8008C18.0248 63.6928 18.0888 63.5368 18.0888 63.3328C18.0888 63.1648 18.0408 63.0388 17.9448 62.9548C17.8488 62.8668 17.6868 62.8048 17.4588 62.7688L17.0148 62.6968C16.6268 62.6288 16.3508 62.4888 16.1868 62.2768C16.0228 62.0608 15.9408 61.8068 15.9408 61.5148C15.9408 61.1148 16.0708 60.8088 16.3308 60.5968C16.5908 60.3808 16.9508 60.2728 17.4108 60.2728C17.7388 60.2728 18.0208 60.3248 18.2568 60.4288C18.4968 60.5328 18.6888 60.6748 18.8328 60.8548L18.3708 61.3468C18.2588 61.2148 18.1248 61.1108 17.9688 61.0348C17.8128 60.9548 17.6288 60.9148 17.4168 60.9148C16.9608 60.9148 16.7328 61.1028 16.7328 61.4788C16.7328 61.6388 16.7808 61.7608 16.8768 61.8448C16.9728 61.9288 17.1368 61.9908 17.3688 62.0308L17.8068 62.1088C18.1708 62.1768 18.4408 62.3108 18.6168 62.5108C18.7928 62.7108 18.8808 62.9668 18.8808 63.2788C18.8808 63.4748 18.8468 63.6548 18.7788 63.8188C18.7108 63.9788 18.6108 64.1188 18.4788 64.2388C18.3468 64.3548 18.1828 64.4448 17.9868 64.5088C17.7948 64.5728 17.5728 64.6048 17.3208 64.6048ZM21.3565 60.9928V64.5328H20.5765V60.9928H19.3165V60.3448H22.6165V60.9928H21.3565ZM24.5642 64.6048C24.2922 64.6048 24.0562 64.5568 23.8562 64.4608C23.6562 64.3608 23.4902 64.2188 23.3582 64.0348C23.2302 63.8508 23.1342 63.6248 23.0702 63.3568C23.0102 63.0888 22.9802 62.7828 22.9802 62.4388C22.9802 62.0988 23.0102 61.7948 23.0702 61.5268C23.1342 61.2548 23.2302 61.0268 23.3582 60.8428C23.4902 60.6588 23.6562 60.5188 23.8562 60.4228C24.0562 60.3228 24.2922 60.2728 24.5642 60.2728C25.1082 60.2728 25.5082 60.4628 25.7642 60.8428C26.0202 61.2228 26.1482 61.7548 26.1482 62.4388C26.1482 63.1228 26.0202 63.6548 25.7642 64.0348C25.5082 64.4148 25.1082 64.6048 24.5642 64.6048ZM24.5642 63.9628C24.7042 63.9628 24.8222 63.9368 24.9182 63.8848C25.0142 63.8288 25.0902 63.7508 25.1462 63.6508C25.2062 63.5508 25.2482 63.4288 25.2722 63.2848C25.3002 63.1368 25.3142 62.9728 25.3142 62.7928V62.0788C25.3142 61.7188 25.2582 61.4348 25.1462 61.2268C25.0382 61.0188 24.8442 60.9148 24.5642 60.9148C24.2842 60.9148 24.0882 61.0188 23.9762 61.2268C23.8682 61.4348 23.8142 61.7188 23.8142 62.0788V62.7988C23.8142 63.1588 23.8682 63.4428 23.9762 63.6508C24.0882 63.8588 24.2842 63.9628 24.5642 63.9628ZM27.4958 61.5268H27.4358V64.5328H26.7638V60.3448H27.7298L28.8278 63.3508H28.8878V60.3448H29.5598V64.5328H28.5938L27.4958 61.5268Z",
    fill: "#FAF7F3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_1133_1348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.333 2C44.333 0.89543 45.2284 0 46.333 0H202.054C203.158 0 204.054 0.895431 204.054 2V9.52435H44.333V2Z",
    fill: "url(#paint3_radial_1133_1348)",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7515 6.26221L49.5736 5.6197H48.8222L48.6479 6.26221H48.1688L48.8803 3.72847H49.5409L50.256 6.26221H49.7515ZM49.2142 4.19674H49.1852L48.9057 5.23129H49.4937L49.2142 4.19674ZM50.5886 3.72847H51.4707C51.7102 3.72847 51.8942 3.78897 52.0224 3.90997C52.1531 4.02855 52.2184 4.19069 52.2184 4.39639C52.2184 4.54159 52.1821 4.65775 52.1095 4.74487C52.0394 4.83199 51.9389 4.89491 51.8082 4.93363V4.95178C51.9607 4.98808 52.0805 5.05463 52.1676 5.15143C52.2572 5.24581 52.3019 5.38012 52.3019 5.55436C52.3019 5.66084 52.2838 5.75764 52.2475 5.84476C52.2136 5.92946 52.164 6.00327 52.0986 6.06619C52.0357 6.12911 51.9583 6.17751 51.8663 6.21139C51.7768 6.24527 51.6751 6.26221 51.5614 6.26221H50.5886V3.72847ZM51.4162 5.91736C51.5493 5.91736 51.6485 5.89316 51.7139 5.84476C51.7816 5.79394 51.8155 5.70803 51.8155 5.58703V5.46724C51.8155 5.34866 51.7816 5.26517 51.7139 5.21677C51.6485 5.16595 51.5493 5.14054 51.4162 5.14054H51.0532V5.91736H51.4162ZM51.3545 4.81021C51.4828 4.81021 51.5771 4.78722 51.6376 4.74124C51.7006 4.69526 51.732 4.6154 51.732 4.50166V4.38187C51.732 4.26813 51.7006 4.18827 51.6376 4.14229C51.5771 4.09631 51.4828 4.07332 51.3545 4.07332H51.0532V4.81021H51.3545ZM53.5637 6.30577C53.3992 6.30577 53.2564 6.27673 53.1354 6.21865C53.0144 6.15815 52.914 6.07224 52.8341 5.96092C52.7567 5.8496 52.6986 5.71287 52.6599 5.55073C52.6236 5.38859 52.6054 5.20346 52.6054 4.99534C52.6054 4.78964 52.6236 4.60572 52.6599 4.44358C52.6986 4.27902 52.7567 4.14108 52.8341 4.02976C52.914 3.91844 53.0144 3.83374 53.1354 3.77566C53.2564 3.71516 53.3992 3.68491 53.5637 3.68491C53.8929 3.68491 54.1349 3.79986 54.2897 4.02976C54.4446 4.25966 54.5221 4.58152 54.5221 4.99534C54.5221 5.40916 54.4446 5.73102 54.2897 5.96092C54.1349 6.19082 53.8929 6.30577 53.5637 6.30577ZM53.5637 5.91736C53.6484 5.91736 53.7198 5.90163 53.7779 5.87017C53.836 5.83629 53.882 5.7891 53.9159 5.7286C53.9522 5.6681 53.9776 5.59429 53.9921 5.50717C54.009 5.41763 54.0175 5.31841 54.0175 5.20951V4.77754C54.0175 4.55974 53.9836 4.38792 53.9159 4.26208C53.8505 4.13624 53.7331 4.07332 53.5637 4.07332C53.3943 4.07332 53.2758 4.13624 53.208 4.26208C53.1427 4.38792 53.11 4.55974 53.11 4.77754V5.21314C53.11 5.43094 53.1427 5.60276 53.208 5.7286C53.2758 5.85444 53.3943 5.91736 53.5637 5.91736ZM55.3519 3.72847V5.30752C55.3519 5.4019 55.3543 5.4866 55.3592 5.56162C55.3664 5.63664 55.3822 5.70077 55.4064 5.75401C55.433 5.80483 55.4717 5.84476 55.5225 5.8738C55.5758 5.90284 55.6484 5.91736 55.7403 5.91736C55.8323 5.91736 55.9037 5.90284 55.9545 5.8738C56.0077 5.84476 56.0465 5.80483 56.0707 5.75401C56.0973 5.70077 56.113 5.63664 56.1178 5.56162C56.1251 5.4866 56.1287 5.4019 56.1287 5.30752V3.72847H56.6043V5.23492C56.6043 5.414 56.5934 5.57009 56.5716 5.70319C56.5498 5.83629 56.5075 5.94761 56.4445 6.03715C56.3816 6.12669 56.2933 6.19445 56.1796 6.24043C56.0682 6.28399 55.9218 6.30577 55.7403 6.30577C55.5588 6.30577 55.4112 6.28399 55.2975 6.24043C55.1861 6.19445 55.099 6.12669 55.0361 6.03715C54.9732 5.94761 54.9308 5.83629 54.9091 5.70319C54.8873 5.57009 54.8764 5.414 54.8764 5.23492V3.72847H55.3519ZM58.1529 4.12051V6.26221H57.681V4.12051H56.9187V3.72847H58.9152V4.12051H58.1529ZM61.8817 3.72847V5.30752C61.8817 5.4019 61.8841 5.4866 61.8889 5.56162C61.8962 5.63664 61.9119 5.70077 61.9361 5.75401C61.9627 5.80483 62.0014 5.84476 62.0523 5.8738C62.1055 5.90284 62.1781 5.91736 62.2701 5.91736C62.362 5.91736 62.4334 5.90284 62.4842 5.8738C62.5375 5.84476 62.5762 5.80483 62.6004 5.75401C62.627 5.70077 62.6427 5.63664 62.6476 5.56162C62.6548 5.4866 62.6585 5.4019 62.6585 5.30752V3.72847H63.134V5.23492C63.134 5.414 63.1231 5.57009 63.1013 5.70319C63.0796 5.83629 63.0372 5.94761 62.9743 6.03715C62.9114 6.12669 62.823 6.19445 62.7093 6.24043C62.598 6.28399 62.4516 6.30577 62.2701 6.30577C62.0886 6.30577 61.9409 6.28399 61.8272 6.24043C61.7159 6.19445 61.6288 6.12669 61.5658 6.03715C61.5029 5.94761 61.4606 5.83629 61.4388 5.70319C61.417 5.57009 61.4061 5.414 61.4061 5.23492V3.72847H61.8817ZM64.4176 6.30577C64.1998 6.30577 64.0135 6.26826 63.8586 6.19324C63.7061 6.11822 63.5815 6.019 63.4847 5.89558L63.7715 5.59792C63.8658 5.70682 63.9675 5.78789 64.0764 5.84113C64.1877 5.89195 64.3063 5.91736 64.4321 5.91736C64.5773 5.91736 64.6886 5.88469 64.7661 5.81935C64.8435 5.75401 64.8822 5.65963 64.8822 5.53621C64.8822 5.43457 64.8532 5.35834 64.7951 5.30752C64.737 5.25428 64.639 5.21677 64.5011 5.19499L64.2325 5.15143C63.9977 5.11029 63.8308 5.02559 63.7315 4.89733C63.6323 4.76665 63.5827 4.61298 63.5827 4.43632C63.5827 4.19432 63.6614 4.00919 63.8187 3.88093C63.976 3.75025 64.1938 3.68491 64.4721 3.68491C64.6705 3.68491 64.8411 3.71637 64.9839 3.77929C65.1291 3.84221 65.2452 3.92812 65.3324 4.03702L65.0529 4.33468C64.9851 4.25482 64.904 4.1919 64.8096 4.14592C64.7153 4.09752 64.6039 4.07332 64.4757 4.07332C64.1998 4.07332 64.0619 4.18706 64.0619 4.41454C64.0619 4.51134 64.0909 4.58515 64.149 4.63597C64.2071 4.68679 64.3063 4.7243 64.4466 4.7485L64.7116 4.79569C64.9319 4.83683 65.0952 4.9179 65.2017 5.0389C65.3082 5.1599 65.3614 5.31478 65.3614 5.50354C65.3614 5.62212 65.3408 5.73102 65.2997 5.83024C65.2586 5.92704 65.1981 6.01174 65.1182 6.08434C65.0383 6.15452 64.9391 6.20897 64.8205 6.24769C64.7044 6.28641 64.5701 6.30577 64.4176 6.30577Z",
    fill: "#FAF7F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1133_1348",
    x: -15.84,
    y: -9.84003,
    width: 229.734,
    height: 129.823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.92002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1133_1348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1133_1348",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_1133_1348",
    x: 28.493,
    y: -15.84,
    width: 191.401,
    height: 126.819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.92002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1133_1348"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.219608 0 0 0 0 0.192157 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1133_1348",
    result: "effect2_dropShadow_1133_1348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1133_1348",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_1133_1348",
    x: 28.493,
    y: -15.84,
    width: 191.401,
    height: 41.2044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.92002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1133_1348"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.219608 0 0 0 0 0.192157 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1133_1348",
    result: "effect2_dropShadow_1133_1348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1133_1348",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1133_1348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8357 18.4594) rotate(23.8473) scale(187.218 321.128)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D7C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1133_1348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6844 12.0781) rotate(27.984) scale(156.376 300.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D7C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1133_1348",
    x1: 19.1666,
    y1: 42.4905,
    x2: 19.1666,
    y2: 55.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1133_1348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.054 9.52435) rotate(-176.587) scale(160.004 39.3682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D7C",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.91d79d17da83a1fbf9600fe9f3361820.svg";
export { ForwardRef as ReactComponent };